import { createStore } from 'satcheljs';
var mailListFilterViewStoreData = {
    filterContextMenuDisplayState: false,
};
export var getStore = createStore('mailListFilterView', mailListFilterViewStoreData);
export var store = getStore();
//# sourceMappingURL=Store.js.map